<template>
  <div class="hello">
  </div>
</template>

<script>
export default {
  name: 'Pruebas',
  props: {
    msg: String
  },
  async mounted(){

      // const _Promesa = await fetch("https://aoe2.net/leaderboard/aoe2de/rm-1v1?length=1000", {
	    //     'mode': 'no-cors',
	    //     'headers': {
      //       	'Access-Control-Allow-Origin': '*',
      //   	}
    	// }).then(imgResponse => {
      //   console.log(imgResponse);
      // });
      
      //console.log("_Resultado");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
